import React from "react";

function ErpDescription({ logo, description }) {
    return (
        <div className="container mx-auto flex flex-col md:flex-row items-center gap-8 text-sm md:text-2xl px-4 md:px-8">
            {/* Left side - Image (1/3) */}
            <div className="w-full lg:w-1/3 flex justify-center">
                <img src={logo} alt="ERP Logo" className="lg:w-[250px]" />
            </div>

            {/* Right side - Content (2/3) */}
            <div className="w-full lg:w-2/3 text-white space-y-4 px-0 md:px-16 text-center md:text-left">
                {/* Removed max-height and overflow for mobile, only apply on desktop */}
                <div className="lg:max-h-[150px] lg:overflow-y-auto custom-scrollbar md:pr-8">
                    {description}
                </div>
            </div>
        </div>
    );
}

export default ErpDescription;
